import React from 'react';
import Utils from '../../utils/Utils';
import * as Constans from './Helpers/Constans';

const getTag = (startTime, endTime) => {
    const tag = {};
    const now = Utils.nowAsTimestampSeconds();
    if(endTime< now){
        //ya paso
        tag.backgroundColor = Constans.PREVIOUS_EVENT_TAG_COLOR;
        tag.label = Constans.PREVIOUS_EVENT_TAG;
    }
    else if(startTime > now){
        tag.backgroundColor = Constans.NEXT_EVENT_TAG_COLOR;
        tag.label = Constans.NEXT_EVENT_TAG;
        //futuro
    }
    else if( startTime<=now && now<endTime){
        // actual
        tag.backgroundColor = Constans.NOW_EVENT_TAG_COLOR;
        tag.label = Constans.NOW_EVENT_TAG;
    }
    else if( startTime === undefined && endTime === undefined){
        tag.backgroundColor = Constans.NOW_EVENT_TAG_COLOR;
        tag.label = Constans.NOW_EVENT_TAG;
    }
    return tag;
}

const EventTagCarrusel = ({ wrapperId, spanId, style, startTime, endTime, text }) => {
    const tag = getTag(startTime, endTime);
    const backgroundColor = tag && tag.backgroundColor ? { backgroundColor: tag.backgroundColor } : {} 
    const size = { width: '42px', height: '18px' }

    return(
        <div
            className="mini-event-tag-container-carrusel mini-row"
            id={wrapperId}
            style={style}>
            <span
                id={spanId}
                className="mini-event-tag-label-carrusel"
            >
                {
                    text
                }
            </span>
        </div>
    );
}

export default EventTagCarrusel;



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/EventTagCarrusel.jsx